import { useEffect, useMemo } from "react";
import { mapLangListToAutocomplete } from "../../../common/utilities/Helper";

export const useSupportiveLanguageOptions = ({ LangList, selectedPrimaryLang }) => {
    return useMemo(() => {
        if (!selectedPrimaryLang?.id) {
            return [];
        }

        return mapLangListToAutocomplete(
            LangList?.filter((item) => item.Id !== selectedPrimaryLang.id)
        );
    }, [selectedPrimaryLang, LangList]);
};

export const useSyncAccountAdminsValidation = ({
    rhfFormInstance,
    accountAdminTableData,
}) => {
    useEffect(() => {
        rhfFormInstance.setValue("accountAdmins", accountAdminTableData, {
            shouldValidate: true,
            shouldTouch: true,
        });
        rhfFormInstance.trigger("accountAdmins");
    }, [rhfFormInstance, accountAdminTableData]);
};
